import { useEffect, useState } from 'react';

/** Formatting and timing helpers for the admin tables. */

const DATE = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium' });
const DATE_TIME = new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' });

export function formatDate(iso: string | null, withTime = false): string {
  if (!iso) {
    return '—';
  }

  return (withTime ? DATE_TIME : DATE).format(new Date(iso));
}

/** `value`, settled for `delayMs` - so a search box is one request per pause, not per key. */
export function useDebounced<T>(value: T, delayMs = 250): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
